import { render, staticRenderFns } from "./Auth2.vue?vue&type=template&id=2031d142&scoped=true"
import script from "./Auth2.vue?vue&type=script&lang=js"
export * from "./Auth2.vue?vue&type=script&lang=js"
import style0 from "./Auth2.vue?vue&type=style&index=0&id=2031d142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2031d142",
  null
  
)

export default component.exports